var _rect, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSupabase = function SvgSupabase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2623_4650)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2755 21.5194C12.7694 22.1567 11.7432 21.8075 11.7311 20.9937L11.5527 9.09082H19.5562C21.0059 9.09082 21.8144 10.7652 20.9129 11.9005L13.2755 21.5194Z",
    fill: "url(#paint0_linear_2623_4650)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2755 21.5194C12.7694 22.1567 11.7432 21.8075 11.7311 20.9937L11.5527 9.09082H19.5562C21.0059 9.09082 21.8144 10.7652 20.9129 11.9005L13.2755 21.5194Z",
    fill: "url(#paint1_linear_2623_4650)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0207 2.36653C10.5268 1.72911 11.553 2.07837 11.5652 2.89219L11.6434 14.7951H3.74005C2.29036 14.7951 1.48184 13.1207 2.3833 11.9854L10.0207 2.36653Z",
    fill: "#3ECF8E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2623_4650",
    x1: 11.5527,
    y1: 11.73,
    x2: 18.666,
    y2: 14.7133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#249361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3ECF8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2623_4650",
    x1: 8.39911,
    y1: 7.41211,
    x2: 11.6431,
    y2: 13.5188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2623_4650"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.292,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
};

export { SvgSupabase as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiBmaWxsPSJ3aGl0ZSIvPgo8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfMjYyM180NjUwKSI+CjxwYXRoIGQ9Ik0xMy4yNzU1IDIxLjUxOTRDMTIuNzY5NCAyMi4xNTY3IDExLjc0MzIgMjEuODA3NSAxMS43MzExIDIwLjk5MzdMMTEuNTUyNyA5LjA5MDgySDE5LjU1NjJDMjEuMDA1OSA5LjA5MDgyIDIxLjgxNDQgMTAuNzY1MiAyMC45MTI5IDExLjkwMDVMMTMuMjc1NSAyMS41MTk0WiIgZmlsbD0idXJsKCNwYWludDBfbGluZWFyXzI2MjNfNDY1MCkiLz4KPHBhdGggZD0iTTEzLjI3NTUgMjEuNTE5NEMxMi43Njk0IDIyLjE1NjcgMTEuNzQzMiAyMS44MDc1IDExLjczMTEgMjAuOTkzN0wxMS41NTI3IDkuMDkwODJIMTkuNTU2MkMyMS4wMDU5IDkuMDkwODIgMjEuODE0NCAxMC43NjUyIDIwLjkxMjkgMTEuOTAwNUwxMy4yNzU1IDIxLjUxOTRaIiBmaWxsPSJ1cmwoI3BhaW50MV9saW5lYXJfMjYyM180NjUwKSIgZmlsbC1vcGFjaXR5PSIwLjIiLz4KPHBhdGggZD0iTTEwLjAyMDcgMi4zNjY1M0MxMC41MjY4IDEuNzI5MTEgMTEuNTUzIDIuMDc4MzcgMTEuNTY1MiAyLjg5MjE5TDExLjY0MzQgMTQuNzk1MUgzLjc0MDA1QzIuMjkwMzYgMTQuNzk1MSAxLjQ4MTg0IDEzLjEyMDcgMi4zODMzIDExLjk4NTRMMTAuMDIwNyAyLjM2NjUzWiIgZmlsbD0iIzNFQ0Y4RSIvPgo8L2c+CjxkZWZzPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXJfMjYyM180NjUwIiB4MT0iMTEuNTUyNyIgeTE9IjExLjczIiB4Mj0iMTguNjY2IiB5Mj0iMTQuNzEzMyIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjMjQ5MzYxIi8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzNFQ0Y4RSIvPgo8L2xpbmVhckdyYWRpZW50Pgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MV9saW5lYXJfMjYyM180NjUwIiB4MT0iOC4zOTkxMSIgeTE9IjcuNDEyMTEiIHgyPSIxMS42NDMxIiB5Mj0iMTMuNTE4OCIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcC8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1vcGFjaXR5PSIwIi8+CjwvbGluZWFyR3JhZGllbnQ+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMjYyM180NjUwIj4KPHJlY3Qgd2lkdGg9IjE5LjI5MiIgaGVpZ2h0PSIyMCIgZmlsbD0id2hpdGUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIgMikiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K";